// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');

// @constants
const { EURO_SYMBOL } = require('constants/index');
const { PERIODICITY } = require('constants/cardPeriodicLoads');
const { CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');

class PeriodicLoadsAppliedFilter extends React.Component {
    buildAmountFilterLabel() {
        const { immFilters, onHandleResetFilters } = this.props;
        const immFilterAmount = immFilters.get('amount');
        const minAmount = immFilterAmount.get('minAmount');
        const maxAmount = immFilterAmount.get('maxAmount');
        const minAmountFormated = getFormattedString({ amount: minAmount, currency: EURO_SYMBOL });
        const maxAmountFormated = getFormattedString({ amount: maxAmount, currency: EURO_SYMBOL });
        const fromElement = minAmount && (
            <span>
                <FormattedText value="filters-min" />
                <span>{minAmountFormated}</span>
            </span>
        );
        const toElement = maxAmount && (
            <span>
                <FormattedText value="filters-max" />
                <span>{maxAmountFormated}</span>
            </span>
        );

        return (
            <LabelFilterRange
                from={fromElement}
                to={toElement}
                closeCallback={() => {
                    onHandleResetFilters('amount');
                }}
            />
        );
    }

    buildPeriodicityFilterLabel() {
        const { immFilters, onHandleResetFilters } = this.props;
        const periodicity = immFilters.getIn(['periodicity', 'periodicity']);
        const periodicityTranslation = formatText(PERIODICITY[periodicity]);
        const fromElement= (
            <span>
                <FormattedText value="cardPeriodicLoads-periodicity" />
                <span>{`: ${periodicityTranslation}`}</span>
            </span>
        );
        return (
            <LabelFilterRange
                from={fromElement}
                closeCallback={() => {
                    onHandleResetFilters('periodicity');
                }}
            />
        );
    }

    buildClearAllFilters() {
        const { immFilters, onHandleClearFilters } = this.props;
        let labelElement;
        if (immFilters.getIn(['amount', 'isActive']) && immFilters.getIn(['periodicity', 'isActive'])) {
            labelElement = (
                <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={onHandleClearFilters} />
            );
        }
        return labelElement;
    }

    render() {
        const { immFilters } = this.props;
        const immFilterAmount = immFilters.get('amount');
        const immFilterPeriodicity = immFilters.get('periodicity');
        const filterAmountLabel = immFilterAmount.get('isActive') ? this.buildAmountFilterLabel() : null;
        const filterPeriodicityLabel = immFilterPeriodicity.get('isActive') ? this.buildPeriodicityFilterLabel() : null;
        const clearAllFilters = this.buildClearAllFilters();
        return(
            <div className="periodic-loads-applied-filters">
                {filterAmountLabel}
                {filterPeriodicityLabel}
                {clearAllFilters}
            </div>
        );
    }
}

PeriodicLoadsAppliedFilter.propTypes = {
    immFilters: PropTypes.object.isRequired,
    onHandleClearFilters: PropTypes.func.isRequired,
    onHandleResetFilters: PropTypes.func.isRequired
}
module.exports = PeriodicLoadsAppliedFilter;
